import { render, staticRenderFns } from "./kpi-achieve-detail.vue?vue&type=template&id=33c01a9c&scoped=true"
import script from "./kpi-achieve-detail.vue?vue&type=script&lang=js"
export * from "./kpi-achieve-detail.vue?vue&type=script&lang=js"
import style0 from "./kpi-achieve-detail.vue?vue&type=style&index=0&id=33c01a9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c01a9c",
  null
  
)

export default component.exports